module.exports = __webpack_public_path__ + "media/pyro-l.a1229fbd.webm";